import { http } from '../../config/axios'

export interface FaturaEnviarEmailRequest {
  idFatura: string
  email: string
  assunto: string
  texto: string
}

export default function postFaturaEnviarEmailService(
  request: FaturaEnviarEmailRequest
): Promise<string> {
  return http
    .post('/api/fatura/enviar-email', request)
    .then((res) => res.data as string)
    .catch((error) => {
      console.error('Erro ao enviar email da fatura', error)
      throw Error(error.response?.data)
    })
}
